import { ComingSoonLanding } from "../../components/ComingSoonLanding.js";
import { MODULES } from "../../lib/modules.js";

const mod = MODULES.find((m) => m.slug === "kb");

export function KbLanding() {
  return (
    <ComingSoonLanding
      title={mod?.label ?? "База знаний"}
      description="Внутренняя справка компании: регламенты, тарифы, FAQ для операторов. Источники — markdown-файлы в git, поиск через KAG/RAG для семантического поиска. Подсказки бота при вопросах клиентов."
      visionDocAnchor="/docs/admin-vision/modules.md#4-база-знаний"
    />
  );
}
